import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      transform="scale(1.2 1.2)"
      d="M9.56329 7.4029C11.6102 5.35596 14.834 5.17176 17.0927 6.85027L14.0175 9.93824V8.57166V7.72666H13.1725H9.23953L9.56329 7.4029ZM6.84951 7.72666L8.36828 6.20789C11.2776 3.29854 16.0181 3.29854 18.9275 6.20789L19.5237 6.80416L18.9287 7.40166L14.0174 12.3334C13.9815 14.8059 11.9318 16.7622 9.47169 16.7622H7.08835C6.90617 16.7778 6.72349 16.7871 6.54069 16.7902L6.48882 16.791L6.43722 16.7855C6.37254 16.7786 6.30797 16.7709 6.24352 16.7622H1.53738H0.692383V15.9172V8.57166V7.72666H1.53738H6.84951ZM6.36444 15.0722C5.32724 14.9118 4.34457 14.4457 3.5428 13.6725L3.435 13.5558L7.48859 9.47759L7.49039 9.47579L7.54952 9.41666H12.3275V11.6353L10.9757 12.9927L10.9744 12.9939L10.5551 13.4133C9.55989 14.4085 8.31513 14.9462 7.01233 15.0722H6.36444ZM2.56703 15.0722H2.38238V14.9013C2.44315 14.9596 2.50471 15.0166 2.56703 15.0722ZM2.38238 12.2175V9.41666H5.16633L2.38238 12.2175Z"
      fill={fill}
    />
  </g>
);

export default Icon;
